import { CTFEntry } from 'types/contentful'

export type Options = {
    width?: number
    height?: number
    format?: 'jpg' | 'png' | 'webp'
}

export type CTFImage = {
    title: string
    description: string
    size: { width: number; height: number }
    url: string
    src: string
    alt?: string
    target?: '_blank' | '_self'
}

export default function parseImage(entry: CTFEntry, opts: Options = {}): CTFImage {
    const size = entry.fields.file.details.image
    let url = 'https:' + entry.fields.file.url
    if (opts) {
        let isFirst = true
        const appendParam = (k: string, v: any) => {
            url += isFirst ? '?' : '&'
            url += `${k}=${v}`
            isFirst = false
        }
        if (opts.width) {
            appendParam('w', opts.width)
            size.width = opts.width
        }
        if (opts.height) {
            appendParam('h', opts.height)
            size.height = opts.height
        }
        if (opts.format) appendParam('fm', opts.format)
    }

    return {
        title: entry.fields.title,
        description: entry.fields.description,
        size,
        url,
        src: url,
        alt: entry.fields.description,
        target: entry.fields.target,
    }
}
